import React from "react";
import AccessLevelFormFields from "components/AccessLevelFormFields";
import { createOne } from "actions/accessLevel";
import { fetchAll } from "actions/user";
import { connect } from "react-redux";
import * as R from "ramda";
import { withRouter } from "react-router-dom";

const mapDispatchToProps = {
  createOne,
  fetchAll
};

const mapStateToProps = state => ({
  isUpdating: state.reader.isUpdating,
  users: state.user.byId,
  isFetching: state.user.isFetching
});

class AdminAccessLevelCreate extends React.Component {
  state = {
    accessLevel: {
      orderer: "Administrator",
      name: "",
      readers: [""],
      user_id: ""
    }
  };

  componentWillMount() {
    this.props.fetchAll();
  }

  handleSubmit = event => {
    event.preventDefault();
    const { createOne, history } = this.props;
    const { accessLevel } = this.state;

    const data = {
      ...accessLevel,
      readers: accessLevel.readers.filter(r => !!r).map(({ id }) => id)
    };

    createOne(data).then(data => {
      history.push("/admin/accesslevel/list");
    });
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  handleReaderChange = (idx, value) => {
    if (value != null) {
      const { users } = this.props;
      const { accessLevel } = this.state;
      value = R.find(
        R.propEq("id", ~~value),
        users[accessLevel.user_id].readers
      );
    }
    this.setState(R.assocPath(["accessLevel", "readers", idx], value));
  };

  render() {
    const { users, isFetching } = this.props;
    const items = Object.keys(users).map(id => users[id]);
    if (!(!isFetching && items)) {
      return null;
    }
    return (
      <form onSubmit={this.handleSubmit}>
        <div style={{ margin: "0 auto" }}>
          <AccessLevelFormFields
            accessLevel={this.state.accessLevel}
            onChange={this.handleChange}
            onReaderChange={this.handleReaderChange}
            users={users}
            user={users[this.state.accessLevel.user_id]}
          />
        </div>
        <div className="form-group">
          <button id="submit" name="submit" className="btn btn-primary">
            Legg til adgangsnivå
          </button>
        </div>
      </form>
    );
  }
}

export default R.compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AdminAccessLevelCreate);



// WEBPACK FOOTER //
// ./src/components/AdminAccessLevelCreate.js